import { faClose, faCopy, faQrcode } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Button from "components/common/button/Button"
import Form from "components/common/form/Form"
import DateInput from "components/common/form/inputs/date/DateInput"
import Input from "components/common/form/inputs/Input"
import FormActions from "components/common/form/partials/FormActions"
import If from "components/common/If"
import Translate from "components/common/Translate"
import { api } from "config/axios-context"
import { useEffect, useState } from "react"
import useAppContext from "utilities/hooks/useAppContext"
import qrcode from "qrcode-generator"

export type ApiTokenFormProps = {
    name: string,
    onSaved: () => void
}

type FormModel = {
    name?: string
    expiredAt?: Date | null
}

const ApiTokenForm = (props: ApiTokenFormProps) => {
    const context = useAppContext();
    const [model, setModel] = useState<FormModel>({ name: '', expiredAt: null });
    const [token, setToken] = useState<string | null>(null);
    const [disableInputs, setDisableInputs] = useState<boolean>(false);

    // useEffect(() => {
    //     const token = 'a7fb0d737092493184decd068e951e169fd03862ef184235a60c1696371845b618f32429e0534a3bb509e65728f63fe664dbb45538ad4cb5bdb803caea2bb64476e42f38367c482f898caf99f212c2e2a7061271193d46f691da63c16a0d091e06a1260a35f1418fa3e444a187ee1062c53b40b5373a43099e09c208707389cde8d18afa67bc4b58a4d0a9e0706e3af4d48cc32862c744399b4997ca5995db62';
    //     setToken(token);
    //     setBarcode();
    // });

    const onSubmit = async () => {
        try {
            setDisableInputs(true);
            const response = await api.post<{ token: string }>('/api/GenerateApiToken', model);
            if (!response.success) {
                throw response.statusText;
            }

            setToken(response.data.token);
        } catch (error) {
            console.error(error);
            context.notify('error', 'form.submit.error');
        } finally {
            setDisableInputs(false);
        }
    }

    const setBarcode = () => {
        if (!token) return
        // if(token) {
        //     // const qr = qrcode(13, 'M');
        //     // qr.addData(token);
        //     const qr = qrcode(1, 'M');
        //     qr.addData('PO00006504-1740161709');
        //     qr.make();
        //     var image = qr.createImgTag(3);
        //     document.getElementById('barcode-img')!.innerHTML = image;
        // }
        setTimeout(() => {
            const qr = qrcode(12, 'L');
            qr.addData(token!);
            qr.make();
            var image = qr.createImgTag(3);
            document.getElementById('barcode-img')!.innerHTML = image;
        }, 10);
    };

    const copy = () => {
        navigator.clipboard.writeText(token || '');
        context.notify('success', 'button.copied');
    }

    return <>
        <If condition={token}>
            <div>
                <div className="justify-self-center w-auto h-auto" id="barcode-img">
                </div>
            </div>
            <div>
                <p className="break-all p-2 bg-neutral-100 dark:bg-neutral-800 border border-transparent rounded" >{token}</p>
            </div>
            <div>
                <p className="p-2 text-sm text-gray-400">
                    <Translate i18nKey="settings.apiToken.keyShowsOnce" />
                </p>
            </div>
            <div className="text-end gap-4 grid">
                <Button title={context.t('buttons.copy')} onClick={() => copy()}>
                    <><FontAwesomeIcon icon={faCopy} /> <Translate i18nKey="buttons.copy" /></>
                </Button>
                <Button title="qrcode" onClick={() => setBarcode()}>
                    <><FontAwesomeIcon icon={faQrcode} /> Qrcode</>
                </Button>
                <Button title={context.t('button.close')} className="bg-danger text-white" onClick={() => props.onSaved()}>
                    <><FontAwesomeIcon icon={faClose} /> {context.t('button.close')}</>
                </Button>
            </div>
        </If>
        <If condition={!token}>
            <Form name={`api-token-form-${props.name}`} onSubmit={onSubmit} >
                <Input
                    name="name"
                    label="fields.name.name"
                    required
                    value={model.name}
                    onChange={e => setModel({ ...model, name: e })}
                    maxLength={64}
                />

                <DateInput
                    name="expiredAt"
                    label="fields.expiredAt.name"
                    value={model.expiredAt || undefined}
                    onChange={e => setModel({ ...model, expiredAt: e })}
                    min={new Date()}
                />

                <FormActions disableInputs={disableInputs} />
            </Form>
        </If>
    </>
}

export default ApiTokenForm
